<!-- =========================================================================================
    File Name: Invoice.vue
    Description: Invoice Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id>
    <vs-popup
      class="holamundo"
      :title="'Anote o protocolo de atendimento'"
      :active.sync="modalProtocolo"
      @close="reloadPage"
    >
      <div class="flex justify-between">
        <h3>{{ this.protocolo }}</h3>

        <vs-button variant="primary" @click.stop.prevent="reloadPage"
          >Ok</vs-button
        >
      </div>
    </vs-popup>
    <div class="p-2">
      <vx-card>
        <form role="form" @submit.stop.prevent autocomplete="off">
          <div>
            <div class="vx-row">
              <div class="vx-col sm:w-1/4 w-full mt-2">
                <label class="ml-3">Identificação</label>
                <div class="flex mt-3 ml-3 mb-2 gap-3">
                  <vs-radio v-model="identificado" vs-value="1">
                    Identificado
                  </vs-radio>
                  <vs-radio v-model="identificado" vs-value="2">
                    Anônimo
                  </vs-radio>
                </div>
              </div>

              <div
                v-if="identificado == '1'"
                class="vx-col sm:w-5/12 w-full mt-2"
              >
                <span>Nome</span>
                <vs-input class="w-full" v-model="form.nome" name="Nome" />
              </div>

              <div
                v-if="identificado == '1'"
                class="vx-col sm:w-1/3 w-full mt-2"
              >
                <span>E-mail</span>
                <vs-input
                  class="w-full"
                  v-model="form.email"
                  name="Email"
                  v-validate="{ email: true }"
                  :state="validateState('Email')"
                  :danger="validateClass('Email')"
                />
              </div>
            </div>

            <div class="vx-row sm:mt-2">
              <div
                v-if="identificado == '1'"
                class="vx-col sm:w-1/3 w-full mt-2"
              >
                <span>Telefone</span>
                <vs-input
                  class="w-full"
                  v-mask="
                    this.form.telefone && this.form.telefone.length <= 14
                      ? '(##) ####-####'
                      : '(##) #####-####'
                  "
                  v-model="form.telefone"
                  name="Telefone"
                />
              </div>

              <div
                v-if="identificado == '1'"
                class="vx-col sm:w-1/3 w-full mt-2"
              >
                <span>CPF/CNPJ</span>
                <vs-input
                  class="w-full"
                  name="CPF"
                  id="CPF"
                  v-model="form.cpfCnpj"
                  :state="validateState('CPF')"
                  :danger="validateClass('CPF')"
                  v-validate="{ min: 14, max: 18 }"
                  v-mask="
                    this.form.cpfCnpj && this.form.cpfCnpj.length <= 14
                      ? '###.###.###-##'
                      : '##.###.###/####-##'
                  "
                  val-icon-danger="clear"
                  danger-text="CPF ou CNPJ incompletos."
                />
              </div>

              <div
                v-if="identificado == '1'"
                class="vx-col sm:w-1/3 w-full mt-2"
              >
                <span>Placa</span>
                <the-mask
                  mask="AAA-#XX#"
                  style="text-transform: uppercase"
                  id="input-2"
                  class="vs-inputx vs-input--input normal hasValue w-full"
                  v-model="form.placa"
                  name="Placa"
                  :masked="true"
                />
              </div>
            </div>
            <div class="vx-row sm:mt-2">
              <div class="vx-col sm:w-1/4 w-full mt-2">
                <span>Tipo de Apontamento</span>
                <v-select
                  :options="tiposIdentificacao"
                  name="tipoIdentificacao"
                  id="tipoIdentificacao"
                  class="select-large w-full"
                  v-model="tipoIdentificacao"
                  @input="selecionaTipoIdentificacao()"
                ></v-select>
              </div>

              <div class="vx-col sm:w-1/4 w-full mt-2">
                <span>Setor</span>
                <v-select
                  :options="setores"
                  name="setor"
                  id="setor"
                  class="select-large w-full"
                  v-model="setor"
                  @input="selecionaSetor()"
                ></v-select>
              </div>

              <div class="vx-col sm:w-1/6 w-full mt-2">
                <span>Estado</span>
                <v-select
                  :options="estados"
                  name="estado"
                  id="estado"
                  class="select-large w-full"
                  v-model="estado"
                  @input="
                    buscaDadosSelectsCidades(
                      'domMunicipio',
                      'cidades',
                      'nomeCidade',
                      'idCidade',
                    ),
                      selecionaEstado()
                  "
                ></v-select>
              </div>

              <div class="vx-col sm:w-1/3 w-full mt-2">
                <span>Cidade</span>
                <v-select
                  :options="cidades"
                  name="cidade"
                  id="cidade"
                  class="select-large w-full"
                  v-model="cidade"
                  @input="selecionaCidade()"
                ></v-select>
              </div>
            </div>

            <div class="vx-row sm:mt-2">
              <div class="vx-col sm:w-1/3 w-full mt-2">
                <span>Assunto</span>
                <vs-input
                  class="w-full"
                  v-model="form.assunto"
                  name="Assunto"
                  v-validate="{ required: true }"
                  :state="validateState('Assunto')"
                  :danger="validateClass('Assunto')"
                  danger-text="Campo Obrigatório"
                />
              </div>
              <div class="vx-col sm:w-1/1 w-full mt-2">
                <vs-textarea
                  label="Descreva brevemente sua mensagem aqui.."
                  v-model="form.mensagem"
                  name="Mensagem"
                  v-validate="{ required: true }"
                  :state="validateState('Mensagem')"
                  :danger="validateClass('Mensagem')"
                  danger-text="Campo Obrigatório"
                />
              </div>
            </div>

            <div class="vx-row">
              <div class="vx-col w-full text-right">
                <vs-button
                  color="dark"
                  @click="buscar"
                  type="gradient"
                  class="mt-2 mt-2"
                  >Enviar</vs-button
                >
              </div>
            </div>
          </div>
        </form>
      </vx-card>
    </div>
  </div>
</template>

<script>
import locale from './../../locale';
import * as lang from 'vuejs-datepicker/src/locale';
import vSelect from 'vue-select';
import service from '../../services';
export default {
  data() {
    return {
      idEmpresa: this.$route.params.idEmpresa,
      estados: [],
      cidades: [],
      setores: [],
      tiposIdentificacao: [],
      languages: lang,
      estado: 'Selecione',
      cidade: 'Selecione',
      tipoIdentificacao: 'Selecione',
      setor: 'Selecione',
      form: {
        idEmpresa: this.$route.params.idEmpresa,
        nome: null,
        email: null,
        telefone: null,
        idSetor: null,
        cidade: null,
        estado: null,
        mensagem: null,
        idTipoIdentificacao: null,
        cpfCnpj: null,
        placa: null,
        assunto: null,
      },
      identificado: 1,
      modalProtocolo: false,
      protocolo: null,
    };
  },
  methods: {
    selecionaEstado() {
      if (!this.estado) {
        this.cidade = null;
        this.form.estado = null;
        return;
      }

      const aux = this.estados.find((x) => x.id == this.estado.id);
      this.form.estado = aux.label;
    },
    selecionaCidade() {
      if (!this.cidade) {
        this.cidade = null;
        this.form.cidade = null;
        return;
      }

      var aux = this.cidades.find((x) => x.id == this.cidade.id);
      this.form.cidade = aux.label;
    },

    selecionaSetor() {
      if (!this.setor) {
        this.setor = null;
        this.form.idSetor = null;
        return;
      }

      var aux = this.setores.find((x) => x.id == this.setor.id);
      this.form.idSetor = aux.id;
    },

    selecionaTipoIdentificacao() {
      if (!this.tipoIdentificacao) {
        this.tipoIdentificacao = null;
        this.form.idTipoIdentificacao = null;
        return;
      }

      var aux = this.tiposIdentificacao.find(
        (x) => x.id == this.tipoIdentificacao.id,
      );
      this.form.idTipoIdentificacao = aux.id;
    },

    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    validateClass(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return this.veeErrors.has(ref);
      }
      return null;
    },
    buscaDadosSelects(model, array, campoDescricao, campoPK) {
      service.getAll('g', {}, `${model}/list/`).then((res) => {
        res.data.forEach((element) => {
          this[array].push({
            id: element[campoPK],
            label: element[campoDescricao],
          });
        });
        this[array].sort(function (a, b) {
          return a.label < b.label ? -1 : a.label > b.label ? 1 : 0;
        });
      });
    },

    buscaDadosSelectsCidades(model, array, campoDescricao, campoPK) {
      if (!this.estado) {
        this[array] = [];
        this.cidade = null;
        return;
      }

      this.$vs.loading();
      this[array] = [];
      if (this.estado && this.estado.id) {
        this.$vs.loading();

        service
          .getAll('g', {}, `${model}/list/codUf/${this.estado.id}`)
          .then((res) => {
            if (res)
              res.data.forEach((element) => {
                this[array].push({
                  id: element[campoPK],
                  label: element[campoDescricao],
                });
              });

            this.$vs.loading.close();
          });
      }
    },
    buscaSetores() {
      return new Promise(async () => {
        this.$vs.loading();
        service
          .getAll('Setor', {}, `list/${this.form.idEmpresa}`)
          .then((res) => {
            res.data.forEach((element) => {
              this.setores.push({
                id: element.idSetor,
                label: element.nomeSetor,
              });
            });
            this.setores.sort(function (a, b) {
              return a.label < b.label ? -1 : a.label > b.label ? 1 : 0;
            });
            this.$vs.loading.close();
          });
      });
    },
    async buscar() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.identificado === '2') {
            this.form.nome = 'Anônimo';
            this.form.email = null;
            this.form.telefone = null;
            this.form.cpfCnpj = null;
            this.form.placa = null;
          }
          this.$vs.loading();
          service
            .post('Ouvidoria', 'InserirOuvidoria', this.form)
            .then((res) => {
              this.protocolo =
                new Date().getFullYear() + `${res.data.idOuvidoria}`;
              this.$vs.loading.close();
              this.foraTabela = false;
              this.$vs.notify({
                position: 'top-center',
                title: 'Obrigado!',
                text: `Sua Requisição foi enviada, aguarde um retorno`,
                color: 'success',
              });
              this.modalProtocolo = true;
            })
            .catch((error) => {
              this.$vs.loading.close();
              this.$vs.notify({
                position: 'top-center',
                title: 'Atenção',
                text: error,
                color: 'danger',
              });
            });
        } else {
          this.$validator.errors.items.forEach((item) => {
            this.$vs.notify({
              position: 'top-center',
              title: 'Atenção',
              text: item.msg,
              color: 'danger',
            });
          });
        }
      });
    },
    reloadPage() {
      window.location.reload();
    },
  },
  mounted() {
    this.buscaDadosSelects('domUf', 'estados', 'nomeUf', 'codUf');
    this.buscaDadosSelects(
      'domTiposIdentificacaoOuvidoria',
      'tiposIdentificacao',
      'tipoIdentificacao',
      'idTipoIdentificacao',
    );
    this.buscaSetores();
    //this.buscaDadosSelects("domMunicipio", "cidades", "nomeCidade", "idCidade");
    this.$validator.localize('ptBr', locale);
  },
  components: { 'v-select': vSelect },
};
</script>
<style>
body {
  background-color: white;
}
.valorprod {
  color: #000;
  font-weight: bolder;
  font-family: 'roboto';
}
.con-slot-label {
  max-width: 90%;
  margin-left: 10px;
}
</style>
